export default __webpack_public_path__ + "book.5891caf0.svg";